import { render } from "./testbuilderdetailview.vue?vue&type=template&id=0537d7e6"
import script from "./testbuilderdetailview.vue?vue&type=script&lang=js"
export * from "./testbuilderdetailview.vue?vue&type=script&lang=js"

import "./testbuilderdetailview.vue?vue&type=style&index=0&id=0537d7e6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__